import {mrbgStore} from './mrbgRedux/index.js';
import React, {useEffect, useState} from 'react';
import chartStyle from '../../static/css/MP_charts.module.css'

function MrbgSpecialSection({id,title}){

	const
		[historyInfo, setHistoryInfo] = useState( mrbgStore.getState().mrbgVars[id]||{} ),
		[myNotif,setMyNotif] = useState(mrbgStore.getState().myNotifications);

	useEffect(() => {
		const unsubscribe = mrbgStore.subscribe(() => {
			setHistoryInfo(mrbgStore.getState().mrbgVars[id]||{});
			setMyNotif(mrbgStore.getState().myNotifications);
		});

		return () => unsubscribe();
	}, []);

	return(
		<div className={chartStyle.clientsHistoryFrame}>
			<div className={chartStyle.MP_frameH2}>
				<h2>{title}</h2>
			</div>
			<table className={chartStyle.specialSection}>
				<tbody>
					{
						Object.keys(historyInfo).map((key,i)=>{
							return(
								<tr className={chartStyle.specialSectionRow} key={i}>
									<th className={`${chartStyle.specialSectionDate} ${Object.keys(myNotif).includes(historyInfo[key].apoSesID.toString())? chartStyle.currentSession: historyInfo[key].apoSesID}`}>{new Date(`${historyInfo[key].beginDateTime.replace(' ', 'T')}Z`).toLocaleString('fa-IR-u-nu-latn', {
										timeZone: 'Asia/Tehran',
										year: 'numeric',
										month: '2-digit',
										day: '2-digit',
										hour: '2-digit',
										minute: '2-digit',
									}).replace(',', '')}</th>
									<td>
										<ul className={chartStyle.specialSectionAreaList}>
											{
												historyInfo[key].areName.map((aName,k2)=> {
													return(
														<li className={chartStyle.mrbgSpecialSectionAreaItem} key={k2}>
															<div>
																<span>{aName}</span>
																<span>{historyInfo[key].operator[k2]}</span>
															</div>
															<div>
																<div>
																	<span>waveLen:</span>
																	<span>{historyInfo[key].waveLength[k2]}</span>
																</div>
																<div>
																	<span>SkinType:</span>
																	<span>{historyInfo[key].skinType[k2]}</span>
																</div>
															</div>
														</li>
													)
												})
											}
										</ul>
									</td>
								</tr>
							)
						})
					}
				</tbody>
			</table>
		</div>
	)
}
export default MrbgSpecialSection;